/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextFields_Outlined from './TextFields_Outlined';
import { SettingsOutlined } from '@material-ui/icons';

export default function Dropdown_Advanced({options, required, style, prompt, id, label, triggerUpdateInParent, isConditional, conditionalField, condReset, renderOther, valueInField, classesToAdd}) {

    function selectOption(e){
        if (e){
          //setQuery("")
          //setValue(val)
          let _value = e.target.textContent;

          // For using the keyboard, for some reason textContent doesn't work and default value
          // will work if we use some else
          if (_value == "" || _value==undefined) {
            setTimeout(function(){
              _value = e.target.defaultValue;
              //alert("AFTER DELAY: "+ _value);
              triggerUpdateInParent(id,_value)
              //alert("VAL: " + _value)
              //setOpen(false);
              checkForOther(_value)
          },100);
              //_value = e.target.defaultValue;
          }
          else{
            triggerUpdateInParent(id,_value)
            //alert("VAL: " + _value)
            //setOpen(false);
            checkForOther(_value)
          }
          
          
        }
      }
      const checkForOther = (val) =>{
        if (renderOther !== undefined)
        {
          if(val == "Other" || valueInField == "Other"){
            renderOther(true)
          }
          else{
            renderOther(false)
          }
        } 
      }
    
    var result = options.filter(match => match.buildingID == conditionalField);
    // /
    //if (id == "schoolDropdown" ) alert("DROPDOWN: " + result)
    /*
    if (condReset){
      if(isConditional && conditionalField == "" && valueInField != "") condReset(id);
      else console.log("NOT COND FOR: " + id)
    }*/

    useEffect(() => {
      const timer = setTimeout(() => {
        if (condReset) {
          if (isConditional && conditionalField == "" && valueInField != ""){ 
            condReset(id);
          }
        }
        //console.log(column1Complete, column2Complete);
      }, 100);
      return () => clearTimeout(timer);
    }, [conditionalField]);

    setTimeout(function(){checkForOther()},500);

    // If there is no style just make the width 220
    if (!style){
      style={
        width: 220
      }
    }

    function convertForDefaultValue(){
      setTimeout(function(){
        let tempIndex = -1;
        for (var i = 0; i < options.length; i++){
          if (options[i].name==valueInField){
            tempIndex = i;
            break;
          }
        }
        //console.log("--------------------------------start"+id)
        //console.log("conditional: " + conditionalField)
        //console.log("value in field: " + valueInField)
        //console.log(options)
        result = options.filter(match => match.buildingID == conditionalField)
        //console.log("--------------------------------end"+id)
        //alert("DEFAULT: " + options[tempIndex])
        return options[tempIndex];
      },500)
      
      
    }

    var emptyJson = [{label: "Empty"}]

    /*
    function setOptionLabel(result){
      if (isConditional && conditionalField == "") return emptyJson.label 
      else return result[label]
    }*/

  return (
    <>
    {required ? <span className="required-field-dropdown">*</span> : <span className="unrequired-field">*</span>}
    <Autocomplete
      id={id}
      className={classesToAdd}
      key={conditionalField}
      options={result}
      size="small"
      defaultValue={convertForDefaultValue() || null}
      //inputValue={(result) => result[label]}
      //getOptionLabel={(option) => option.title}
      getOptionLabel={isConditional && conditionalField == "" ? emptyJson.label : (result) => result[label]}
      //getOptionLabel={setOptionLabel(result)}
      style={style}
      onChange={(e)=>selectOption(e)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={prompt}
          variant="outlined"
          autoComplete="off" // <-- This disables browser autocomplete
        />
      )}
    />
    </>
  );
}